import PlansGrid from "@/components/PlansGrid";
import { useAccount } from "@/lib/account";
import { usePrefs } from "@/lib/prefs";

export default function Plans() {
  const { account } = useAccount();
  const { t } = usePrefs();
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 mandala-bg" data-testid="plans-page">
      <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">Membership</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-3">{t("plansTitle")}</h1>
      <p className="text-slate-400 mt-4 max-w-xl" data-testid="plans-pricing-note">{t("plansSub")}</p>
      {account?.plan_active && (
        <p className="mt-6 inline-block px-4 py-2 rounded-full bg-emerald-950/70 border border-emerald-500/30 text-emerald-300 text-sm" data-testid="plans-active-plan">
          Active: {account.plan} until {new Date(account.plan_expires).toLocaleDateString("en-IN")}
        </p>
      )}
      <div className="mt-14"><PlansGrid /></div>
    </div>
  );
}
